<template>
  <div>
    <div class="row d-flex flex-row list__section align-items-center justify-content-between">
      <!-- column 1 -->
      <div class="col-4">
        <!-- Learning Unit name -->
        <div v-if="learningUnit && showLearningUnitName">
          <b class="header__title text__lu-name">{{ learningUnit.name }}</b>
        </div>

        <!-- Date start-end -->
        <div class="section__available-time text-dark my-2">
          {{
            `${formatedDatetime(section.start_at, 'MMM D, YYYY hh:mma')} - ${formatedDatetime(
              section.end_at,
              'MMM D, YYYY hh:mma'
            )}`
          }}
        </div>

        <!-- Last enrollment -->
        <div v-if="showLastEnrollmentTime" class="section__last-enrollment-time text-dark mb-2">
          Last enrollment:
          {{ formatedDatetime(section.last_enrollment, 'MMM D, YYYY hh:mma') }}
        </div>

        <!-- Status -->
        <div v-if="showStatus" class="container__status d-flex">
          <div v-if="section.is_published === true">
            <b-badge
              pill
              variant="neutral-info"
              class="section__status status--published text-info"
            >
              Published
            </b-badge>
          </div>
          <div v-if="!section.is_published">
            <b-badge pill variant="neutral-dark" class="section__status status--draft text-dark">
              Draft
            </b-badge>
          </div>
          <div>
            <b-badge
              v-if="today('toISOString') > section.end_at"
              pill
              variant="neutral-dark"
              class="section__status status--passed ml-2 mr-auto"
            >
              <span class="font-weight-bold text-dark">PASSED</span>
            </b-badge>
          </div>
        </div>
      </div>

      <!-- column 2 -->
      <meeting-section
        v-if="learningUnit"
        class="col-4"
        :section="section"
        :number-of-online-meeting="learningUnit.number_of_online_meeting"
      />

      <!-- column 3 -->
      <div class="col-1 section__enrolled-slots">
        <div :id="`section-${section.id}-enrolled-slots`" class="mt-1 mb-2">
          {{ section.number_of_learners ? section.number_of_learners : 0 }}/{{
            section.max_learners
          }}
        </div>
        <div class="text-dark">Enrolled</div>
      </div>

      <!-- column 4 -->
      <div class="col-3 d-flex justify-content-center align-self-center">
        <b-button variant="outline-primary" @click="goToTeachingFeedPage()">
          Teaching Feed
        </b-button>
      </div>

      <!-- <ModalDeleteSection
        :ref="`modalDelete__${section.id}`"
        :section="section"
        :title-time="{
          start_at: formatedDatetime(section.start_at, 'MMM D, YYYY hh:mma'),
          end_at: formatedDatetime(section.end_at, 'MMM D, YYYY hh:mma'),
          city_timezone: cityTimezone,
        }"
        :index="index"
        @emitDeleteSection="emitDeleteSection"
      /> -->
    </div>

    <div class="divider my-4" />
  </div>
</template>

<script>
import moment from 'moment';

// import BaseEllipsis from "@/components/base-components/BaseEllipsis";
// import ModalDeleteSection from "./ModalDeleteSection";
// import { sectionMixin } from "@/mixins/sectionMixin";
import { datetimeMixin } from '@/mixins/datetimeMixin';
import MeetingSection from './MeetingSection';
import LearningUnit from '@/models/LearningUnit';

export default {
  components: {
    // BaseLists,
    // BaseEllipsis,
    // ModalDeleteSection,
    MeetingSection
  },

  mixins: [datetimeMixin],

  props: {
    /**
     * Recieving each section from Section tab
     *
     * @type {Object}
     */
    learningUnit: {
      type: LearningUnit,
      required: true
    },

    /**
     * Recieving each section from Section tab
     *
     * @type {Object}
     */
    section: {
      type: Object,
      default: () => {}
    },

    /**
     * Indexing each item of Section
     *
     * @type {Number}
     */
    index: {
      type: Number,
      default: null
    },

    showLearningUnitName: {
      type: Boolean,
      default: () => false
    },

    showLastEnrollmentTime: {
      type: Boolean,
      default: () => true
    },

    showStatus: {
      type: Boolean,
      default: () => true
    },

    editable: {
      type: Boolean,
      default: () => true
    },

    previousPath: {
      type: String,
      default: ''
    }
  },

  computed: {
    passEndDate() {
      return new Date(this.section.end_at) < new Date();
    },

    utcTime() {
      return (time) => moment(time, 'HH:mm:ss.sss').format('HH:mm:ssZ');
    }
  },

  methods: {
    goToTeachingFeedPage() {
      let query = {};

      if (this.previousPath) {
        this.$set(query, 'previousPath', this.previousPath);
      }
      this.$router.push({
        name: 'design-planning/teaching-feed',
        query: {
          ...query,
          view: 'feed',
          tab: 'posts'
        },
        params: {
          sectionId: this.section.id,
          learningUnitId: this.section.learning_unit_id
        }
      });
    }

    // /**
    //  * Trigger open modal component
    //  */
    // showModal(modalType) {
    //   this.$refs[modalType].show(modalType);
    // },

    // emitDeleteSection(index) {
    //   this.$emit("emitDeleteSection", index);
    // },
  }
};
</script>

<style lang="scss" scoped>
.meeting {
  padding: 0 1rem;

  display: flex;
  flex-flow: column wrap;
  justify-content: flex-start;
  align-items: flex-start;
  // flex-basis: 30%;

  &__week-day {
    align-self: flex-start;
    margin-bottom: 0.25rem;
  }

  &__circle-day {
    color: var(--gray-dark);
    background-color: var(--light);
    font-size: 0.65rem;
    font-weight: 600;
    padding: 0.4rem 0.65rem;
    border-radius: 50%;
    &:not(:last-child) {
      margin-right: 0.5rem;
    }
    &--active {
      color: var(--white);
      background-color: var(--primary);
    }
  }

  &__repeat-time {
    margin: 0.5rem 0;
  }

  &__detail {
    position: relative;
  }

  &__show-details {
    width: 6rem;
    color: var(--primary);
    cursor: pointer;
    // position: absolute;
    // top: 0;
    // left: 0;
    transition: all 0.3s;

    &:hover,
    &:active {
      transform: translateY(-1px);
    }
  }
}
</style>
